import { render, staticRenderFns } from "./CaseIdentities.vue?vue&type=template&id=653174d3&"
import script from "./CaseIdentities.vue?vue&type=script&lang=js&"
export * from "./CaseIdentities.vue?vue&type=script&lang=js&"
import style0 from "./CaseIdentities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports